module.exports = __webpack_public_path__ + "img/closeup_lobby.218d7442.jpg";